import { SiteContent } from '../types/siteContent';
import { AGENCY_CONFIG } from './agency';

export const DEFAULT_SITE_CONTENT: SiteContent = {
  branding: {
    siteTitle: 'Варна Имотен Център',
    siteSlogan: 'Професионални имотни консултанти',
    logoUrl: '/imotencenterlogo-cropped.png',
    logoAlt: 'Варна Имотен Център Лого',
    faviconUrl: '/imotencenterlogo-cropped.png',
    logoHeight: 48,
    headingFont: 'Montserrat',
    bodyFont: 'Inter',
    accentColor: '#C5A46E',
    darkBgColor: '#0F1E32',
  },

  navigation: {
    topBar: {
      showTopBar: true,
      addressText: AGENCY_CONFIG.address,
      phone: AGENCY_CONFIG.phone,
      email: AGENCY_CONFIG.email,
      facebookUrl: 'https://facebook.com',
      instagramUrl: 'https://instagram.com',
      linkedinUrl: 'https://linkedin.com',
    },
    menuLabels: {
      sales: 'Продажби',
      rentals: 'Наеми',
      services: 'Услуги',
      about: 'За нас',
      team: 'Екип',
      contacts: 'Контакти',
    },
    headerButton: {
      show: true,
      text: 'Безплатна консултация',
    },
  },

  hero: {
    badge: 'ИМОТИ ВЪВ ВАРНА • ПРОДАЖБИ • НАЕМИ • КОНСУЛТАЦИИ',
    titleLine1: 'Открийте точния',
    titleLine2: 'имот във Варна.',
    subtitle: 'Продажби, наеми и професионално съдействие за Вашия дом или инвестиция.',
    bgImage: '/hero.webp',
    buttonSalesText: 'Разгледай продажби',
    buttonRentalsText: 'Разгледай наеми',
    interactiveBadges: {
      salesBadge: 'Продажби',
      rentalsBadge: 'Наеми',
      documentsBadge: 'Подготовка на документи',
    },
    trustBadges: {
      badge1: 'Актуални оферти',
      badge2: 'Коректно обслужване',
      badge3: 'Лично отношение',
    },
    featuredPropertyId: '',
  },

  featuredSection: {
    title: 'Подбрани оферти',
    subtitle: 'Ръчно избрани специални предложения за имоти в топ районите на Варна.',
    viewAllButtonText: 'Виж всички оферти →',
  },

  servicesSection: {
    badge: 'КАКВО ПРЕДЛАГАМЕ',
    title: 'Нашите услуги',
    subtitle: 'Пълен набор от първокласни брокерски и правни решения при покупка, продажба и отдаване на недвижими имоти във Варна.',
    teaserCards: [
      {
        id: 's1',
        title: 'Покупка и продажба',
        description: 'Пълно съдействие при избор на имот или намиране на надежден купувач. Анализ на реалните пазарни цени.',
        buttonText: 'Научете повече →',
      },
      {
        id: 's2',
        title: 'Наеми и управление',
        description: 'Отдаване под наем на апартаменти и търговски площи. Проверка на наематели и защита на интересите Ви.',
        buttonText: 'Научете повече →',
      },
      {
        id: 's3',
        title: 'Консултации и оценка',
        description: 'Правна проверка на документи, пазарна оценка, съдействие при жилищно кредитиране и изповядване.',
        buttonText: 'Научете повече →',
      },
    ],
  },

  aboutSection: {
    badge: 'ЗА АГЕНЦИЯТА',
    title: 'Нашата история и мисия',
    paragraph1: 'Варна Имотен Център е създадена с ясна визия — да осигури сигурност, прозрачност и професионализъм на пазара на недвижими имоти във Варна.',
    paragraph2: 'Нашият екип от лицензирани брокери познава в детайли всеки квартал на града. Подхождаме персонално към всеки клиент, спестявайки време, средства и излишни рискове при изповядване на сделката.',
    image: 'https://images.unsplash.com/photo-1600585154340-be6161a56a0c?w=800&auto=format&fit=crop&q=80',
    buttonText: 'Научете повече за нас →',
    reviewsBadge: '',
    reviewsTitle: 'Какво споделят клиентите за нас',
    reviewsSubtitle: 'Скрийншоти и оценки от доволни купувачи, продавачи и наематели във Варна',
    googleReviewsUrl: 'https://maps.google.com/',
    googleReviewsScreenshots: [],
    reviewsRating: 5.0,
    reviewsRatingText: '5.0 Рейтинг в Google',
  },

  teamSection: {
    badge: 'НАШИТЕ ЛИЧНОСТИ',
    title: 'Запознайте се с нашия екип',
    subtitle: 'Обучени експерти с десетилетен опит на варненския пазар, готови да защитят всеки Ваш интерес.',
    viewAllButtonText: 'Виж целия екип →',
  },

  ctaBanner: {
    titlePrefix: 'Готови ли сте да откриете ',
    highlightedText: 'точния имот',
    titleSuffix: ' във Варна?',
    subtitle: 'Свържете се с нашия екип днес за безплатна първоначална консултация и преглед на най-новите оферти.',
    phoneButtonText: 'Обадете се сега',
    contactButtonText: 'Изпрати запитване',
    bgImage: 'https://images.unsplash.com/photo-1512917774080-9991f1c4c750?w=1600&auto=format&fit=crop&q=80',
  },

  salesPage: {
    badge: 'АКТУАЛНИ ПРЕДЛОЖЕНИЯ',
    title: 'Имоти за продажба',
    subtitle: 'Разгледайте богатата ни селекция от проверени апартаменти, къщи и инвестиционни проекти във Варна.',
    bgImage: 'https://images.unsplash.com/photo-1545324418-cc1a3fa10c00?w=1600&auto=format&fit=crop&q=80',
  },

  rentalsPage: {
    badge: 'ДЪЛГОСРОЧНИ И СИГУРНИ НАЕМИ',
    title: 'Имоти под наем',
    subtitle: 'Намерете своя идеален апартамент, дом или търговски магазин под наем във Варна.',
    bgImage: 'https://images.unsplash.com/photo-1545324418-cc1a3fa10c00?w=1600&auto=format&fit=crop&q=80',
    howWeWorkBadge: 'ЕТАПИ С НАЕМАТЕЛИ',
    howWeWorkTitle: 'Как работим при наемане',
    howWeWorkSubtitle: 'Ние правим целия процес по намиране на жилище улеснен, структуриран и напълно законен.',
    steps: [
      {
        number: '01',
        title: 'Разбираме нуждите Ви',
        description: 'Уточняваме точните изисквания за локация, площ, брой спални, бюджет и наличие на домашни любимци.',
      },
      {
        number: '02',
        title: 'Подбираме оферти',
        description: 'Професионално селектираме само 100% реални и актуални обяви, съвпадащи напълно с Вашите очаквания.',
      },
      {
        number: '03',
        title: 'Организираме огледи',
        description: 'Организираме физически огледи в удобно за Вас часово време, давайки обективен анализ за състоянието на имота.',
      },
      {
        number: '04',
        title: 'Съдействаме с договор',
        description: 'Правно изготвяне на надеждни двустранни договори за наем и двустранен приемо-предавателен опис.',
      },
    ],
    requestBanner: {
      badge: 'НЕ ОТКРИВАТЕ ОФЕРТА?',
      title: 'Изпратете ни писмено запитване',
      subtitle: 'Споделете какво търсите (квартал, стаи, цена). Нашите брокери ще намерят имоти извън пазара за Вас!',
      buttonText: 'ИЗПРАТИ ЗАПИТВАНЕ 📨',
    },
  },

  servicesPage: {
    badge: 'КАКВО ВКЛЮЧВАТ УСЛУГИТЕ НИ',
    title: 'Услуги за сигурни сделки',
    subtitle: 'Професионална подкрепа от първия разговор до получаването на ключовете за Вашия нов имот.',
    bgImage: 'https://images.unsplash.com/photo-1545324418-cc1a3fa10c00?w=1600&auto=format&fit=crop&q=80',
    faqBadge: 'ЧЕСТО ЗАДАВАНИ ВЪПРОСИ',
    faqTitle: 'Отговори на Вашите въпроси',
    faqSubtitle: 'Всичко най-важно за работата с брокерски агенции и изповядване на сделки.',
    servicesList: [
      {
        id: 'sec-1',
        title: 'ПОСРЕДНИЧЕСТВО ПРИ СДЕЛКА',
        description: 'Професионално посредничество при покупко-продажба и отдаване или наемане на имоти. Ние защитаваме Вашите интереси и Ви осигуряваме сигурност.',
        icon: 'Handshake',
        details: [
          'Маркетинг и реклама на Вашата оферта в най-големите платформи',
          'Провеждане на огледи от обучени топ брокери',
          'Осигуряване на реален пазарен интерес и филтрация на сериозни купувачи',
          'Финансови преговори за достигане на максимална пазарна цена'
        ]
      },
      {
        id: 'sec-2',
        title: 'ПОДГОТОВКА НА ДОКУМЕНТИ',
        description: 'Пълно правно и документално проучване на имоти, за да се гарантира изрядността на сделката без скрити рискове.',
        icon: 'FileText',
        details: [
          'Изготвяне на Предварителни договори по ЗЗД',
          'Проверка за вещни тежести, ипотеки, съдебни спорове и възбрани',
          'Снабдяване с данъчни оценки, кадастрални схеми и удостоверения',
          'Координация с нотариус и подготовка на Нотариални актове'
        ]
      },
      {
        id: 'sec-3',
        title: 'КОНСУЛТАЦИИ И АНАЛИЗИ',
        description: 'Предоставяме детайлна картина за динамиката на пазара на имоти във Варна и областта, за да направите най-добрия избор за инвестиция.',
        icon: 'TrendingUp',
        details: [
          'Безплатни първоначални пазарни оценки',
          'Актуални статистически анализи на цените по райони и квартали',
          'Инвестиционни съвети с изчисление на възвръщаемост (ROI) на наеми',
          'Консултация за кредитиране - партньорство с водещи банки за супер лихви'
        ]
      },
      {
        id: 'sec-4',
        title: 'СЪДЕЙСТВИЕ ДО КРАЙ',
        description: 'Първата ни среща е само началото. Ние стоим до Вас при фактическото предаване на имота, деклариране и допълнителни ангажименти.',
        icon: 'Heart',
        details: [
          'Физическо предаване на имота с приемо-предавателен протокол',
          'Смяна на партиди за ток, вода, Енерго-Про, ВиК и Топлофикация',
          'Помощ при деклариране в местната община и НАП',
          'Съвети при интериорен дизайн, ремонт или бъдещо управление'
        ]
      }
    ]
  },

  teamPage: {
    badge: 'НАШИЯТ НАЙ-ГОЛЯМ АКТИВ',
    title: 'Компетентни консултанти',
    subtitle: 'Професионален екип от сертифицирани брокери, работещи съвестно за Вас всеки ден.',
    bgImage: 'https://images.unsplash.com/photo-1545324418-cc1a3fa10c00?w=1600&auto=format&fit=crop&q=80',
  },

  contactsPage: {
    badge: 'ГРАД ВАРНА - ОФИС И КОНТАКТИ',
    title: 'Свържете се с нас',
    subtitle: 'Нашият екип е на разположение 7 дни в седмицата. Посетете нашия офис за топла консултация.',
    bgImage: 'https://images.unsplash.com/photo-1545324418-cc1a3fa10c00?w=1600&auto=format&fit=crop&q=80',
    companyName: 'Варна Имотен Център',
    address: AGENCY_CONFIG.address,
    phone1: AGENCY_CONFIG.phone,
    phone2: AGENCY_CONFIG.secondaryPhone,
    email: AGENCY_CONFIG.email,
    workingHoursWeekdays: 'Понеделник – Петък: 09:00 – 18:30 ч.',
    workingHoursSaturday: 'Събота: 10:00 – 15:00 ч.',
    workingHoursSunday: 'Неделя: Почивен ден (само спешни огледи)',
    mapHeading: 'Локация на Офиса',
    mapNote: 'Офисът се намира в непосредствена близост до Окръжна болница.',
    formTitle: 'Изпратете ни писмено съобщение',
    formSubtitle: 'Имате въпроси за покупка, продажба или искате да обсъдим оферта? Попълнете формата и наш експерт ще се свърже с Вас.',
    formButtonText: 'Изпрати Имейл 📨',
  },

  footer: {
    aboutText: 'Вашият доверен партньор за покупка, продажба и наем на недвижими имоти в град Варна. Дългогодишен опит, сигурност и индивидуално отношение.',
    address: AGENCY_CONFIG.address,
    phone: AGENCY_CONFIG.phone,
    email: AGENCY_CONFIG.email,
    quickLinksTitle: 'БЪРЗИ ВРЪЗКИ',
    quickLinks: [
      { id: 'ql-1', label: 'Начало', tab: 'home' },
      { id: 'ql-about', label: 'За нас', tab: 'about' },
      { id: 'ql-2', label: 'Имоти за Продажба', tab: 'sales' },
      { id: 'ql-3', label: 'Имоти под Наем', tab: 'rentals' },
      { id: 'ql-4', label: 'Нашите Услуги', tab: 'services' },
      { id: 'ql-5', label: 'Нашият Екип', tab: 'team' },
      { id: 'ql-6', label: 'Контакти', tab: 'contacts' },
    ],
    popularLocationsTitle: 'ПОПУЛЯРНИ ЛОКАЦИИ',
    popularLocations: [
      { id: 'pl-1', name: 'Имоти в Бриз', neighborhood: 'Бриз' },
      { id: 'pl-2', name: 'Имоти в Чайка', neighborhood: 'Чайка' },
      { id: 'pl-3', name: 'Имоти в Левски', neighborhood: 'Левски' },
      { id: 'pl-4', name: 'Имоти в Център', neighborhood: 'Център' },
      { id: 'pl-5', name: 'Имоти в Гръцка махала', neighborhood: 'Гръцка махала' },
      { id: 'pl-6', name: 'Имоти във Възраждане', neighborhood: 'Възраждане' },
      { id: 'pl-7', name: 'Имоти в Св. Св. Константин', neighborhood: 'Св. Св. Константин и Елена' },
    ],
    servicesTitle: 'НАШИТЕ УСЛУГИ',
    servicesList: [
      { id: 'sl-1', title: 'Посредничество при покупка' },
      { id: 'sl-2', title: 'Продажба на жилища и парцели' },
      { id: 'sl-3', title: 'Дългосрочни и сезонни наеми' },
      { id: 'sl-4', title: 'Правна експертиза на документи' },
      { id: 'sl-5', title: 'Кредитно съдействие и оценки' },
      { id: 'sl-6', title: 'Управление на имоти' },
    ],
    social: {
      facebook: 'https://facebook.com',
      instagram: 'https://instagram.com',
      linkedin: 'https://linkedin.com',
    },
    mapSection: {
      enabled: true,
      badge: 'ОФИС И ЛОКАЦИЯ',
      title: 'Централен офис Варна',
      subtitle: 'Заповядайте на място за лична консултация, обсъждане на оферти или подписване на документи.',
      address: AGENCY_CONFIG.address,
      landmark: 'В непосредствена близост до Окръжна болница (бул. Генерал Колев)',
      workingHours: 'Пон – Пет: 09:00 – 18:00 ч. | Събота: 10:00 – 14:00 ч.',
      phone: AGENCY_CONFIG.phone,
    },
    privacyText: 'Политика за поверителност',
    termsText: 'Общи условия',
    copyrightText: 'Варна Имотен Център ЕООД. Всички права запазени.',
    creditsText: 'Лицензирана агенция за недвижими имоти гр. Варна',
  },

  seo: {
    siteName: 'Варна Имотен Център',
    siteUrl: 'https://imotencentervarna.com',
    defaultOgImage: '/hero.webp',
    defaultFocusKeyword: 'имоти Варна',
    structuredDataEnabled: true,
    pages: {
      home: {
        id: 'home',
        pageName: 'Начална страница',
        urlPath: '/',
        metaTitle: 'Варна Имотен Център - Продажби и Наеми на Имоти във Варна',
        metaDescription: 'Търсите имот във Варна? Ние предлагаме 100% проверени оферти за покупка и наем на апартаменти, къщи и търговски площи. Лично отношение и сигурност.',
        focusKeyword: 'имоти Варна',
        secondaryKeywords: 'недвижими имоти Варна, апартаменти Варна, агенция за имоти Варна, имотен център Варна',
        h1: 'Открийте точния имот във Варна',
        h2: 'Продажби, наеми и професионално съдействие за Вашия дом или инвестиция',
        pageDescription: 'Лицензирана агенция за недвижими имоти във Варна. Пълно съдействие при покупко-продажба, отдаване под наем, проверка на тежести и ипотечни кредити.',
        ogImage: '',
        ogTitle: 'Варна Имотен Център - Точният имот във Варна',
        ogDescription: '100% реални оферти за продажби и наеми на имоти във Варна с проверени документи и професионално съдействие.',
        canonicalUrl: 'https://imotencentervarna.com/',
        imageAltHero: 'Модерна жилищна сграда и имоти във Варна - Варна Имотен Център',
        imageAltSecondary: 'Луксозен интериор на апартамент във Варна',
        noIndex: false
      },
      sales: {
        id: 'sales',
        pageName: 'Продажби',
        urlPath: '/prodazhbi',
        metaTitle: 'Имоти за продажба във Варна - Апартаменти и Къщи | Варна Имотен Център',
        metaDescription: 'Каталог с имоти за продажба във Варна: едностайни, двустайни, тристайни апартаменти и къщи в Бриз, Чайка, Център, Левски. Без скрити комисиони.',
        focusKeyword: 'имоти за продажба Варна',
        secondaryKeywords: 'апартаменти за продажба Варна, купува имот Варна, продажба на жилища Варна, евтини апартаменти Варна',
        h1: 'Имоти за продажба във Варна',
        h2: 'Купете сигурно своето ново жилище или инвестиционен имот',
        pageDescription: 'Открийте перфектните реални оферти за покупка на Вашия нов дом или инвестиционен имот в град Варна с юридическа сигурност.',
        ogImage: 'https://images.unsplash.com/photo-1600596542815-ffad4c1539a9?w=1200&h=630&fit=crop&q=80',
        ogTitle: 'Имоти за продажба във Варна - Проверени Оферти',
        ogDescription: 'Разгледайте актуални жилища за продажба във Варна с реални цени, параметри и снимки.',
        canonicalUrl: 'https://imotencentervarna.com/prodazhbi',
        imageAltHero: 'Апартаменти и имоти за продажба във Варна',
        imageAltSecondary: 'Просторна дневна в модерен апартамент за продажба Варна',
        noIndex: false
      },
      rentals: {
        id: 'rentals',
        pageName: 'Наеми',
        urlPath: '/naemi',
        metaTitle: 'Имоти под наем Варна - Дългосрочни Наеми на Апартаменти | Варна Имотен Център',
        metaDescription: 'Търсите апартамент под наем във Варна? Обзаведени жилища в топ квартали: Център, Бриз, Чайка, Виница. Двустранен договор и коректни наемодатели.',
        focusKeyword: 'имоти под наем Варна',
        secondaryKeywords: 'апартаменти под наем Варна, наеми Варна, двустаен под наем Варна, дългосрочен наем Варна',
        h1: 'Имоти под наем във Варна',
        h2: 'Дългосрочни и сигурни наеми с проверени наемодатели и договори',
        pageDescription: 'Намерете своя идеален апартамент, дом или търговски магазин под наем във Варна с професионален приемо-предавателен протокол.',
        ogImage: 'https://images.unsplash.com/photo-1502672260266-1c1ef2d93688?w=1200&h=630&fit=crop&q=80',
        ogTitle: 'Имоти под наем Варна - Реални Апартаменти',
        ogDescription: 'Намерете идеалния дом под наем във Варна бързо, изгодно и напълно безрисково.',
        canonicalUrl: 'https://imotencentervarna.com/naemi',
        imageAltHero: 'Уютен обзаведен апартамент под наем във Варна',
        imageAltSecondary: 'Модерна спалня и интериор на жилище под наем Варна',
        noIndex: false
      },
      services: {
        id: 'services',
        pageName: 'Услуги',
        urlPath: '/uslugi',
        metaTitle: 'Брокерски и Правни Услуги за Недвижими Имоти Варна | Варна Имотен Център',
        metaDescription: 'Комплексни услуги за недвижими имоти във Варна: посредничество, изготвяне на нотариални актове, кадастрални скици, данъчни оценки и банково кредитиране.',
        focusKeyword: 'услуги недвижими имоти Варна',
        secondaryKeywords: 'правни услуги имоти Варна, данъчна оценка Варна, проверка на имот, съдействие за кредит',
        h1: 'Услуги за сигурни сделки с имоти',
        h2: 'Пълно съдействие от първия оглед до нотариалното изповядване',
        pageDescription: 'Професионална подкрепа от първия разговор до получаването на ключовете за Вашия нов имот с гарантирана правна чистота.',
        ogImage: 'https://images.unsplash.com/photo-1450133064473-71024230f91b?w=1200&h=630&fit=crop&q=80',
        ogTitle: 'Брокерски и Правни Услуги - Варна Имотен Център',
        ogDescription: 'Професионални консултации, проверка на тежести и финансиране на имоти във Варна.',
        canonicalUrl: 'https://imotencentervarna.com/uslugi',
        imageAltHero: 'Консултация и подписване на документи за имот Варна',
        imageAltSecondary: 'Юридическа проверка на нотариални актове и кадастрални скици',
        noIndex: false
      },
      team: {
        id: 'team',
        pageName: 'Екип',
        urlPath: '/ekip',
        metaTitle: 'Нашият Екип от Брокери и Консултанти | Варна Имотен Център',
        metaDescription: 'Запознайте се с опитните брокери и имотни експерти на Варна Имотен Център. Лично отношение, отлични преговорни умения и професионализъм.',
        focusKeyword: 'брокери Варна',
        secondaryKeywords: 'агенти недвижими имоти Варна, брокерска агенция Варна, най-добрите брокери Варна',
        h1: 'Компетентни имотни консултанти във Варна',
        h2: 'Професионален екип от сертифицирани брокери, работещи съвестно за Вас',
        pageDescription: 'Нашите консултанти са специализирани по райони във Варна, за да Ви осигурят най-добрата пазарна цена и спокойствие при сделката.',
        ogImage: 'https://images.unsplash.com/photo-1560518883-ce09059eeffa?w=1200&h=630&fit=crop&q=80',
        ogTitle: 'Екипът на Варна Имотен Център',
        ogDescription: 'Свържете се с персонален брокер за продажба, покупка или наем на имот във Варна.',
        canonicalUrl: 'https://imotencentervarna.com/ekip',
        imageAltHero: 'Екип от брокери на Варна Имотен Център',
        imageAltSecondary: 'Имотен консултант провежда среща с клиенти',
        noIndex: false
      },
      contacts: {
        id: 'contacts',
        pageName: 'Контакти',
        urlPath: '/kontakti',
        metaTitle: 'Контакти и Офис във Варна | Варна Имотен Център - бул. Ген. Колев 113',
        metaDescription: `Свържете се с Варна Имотен Център: адрес бул. Генерал Колев 113, Варна. Телефон: ${AGENCY_CONFIG.phone}. Работно време: понеделник - петък 09:00 - 18:00.`,
        focusKeyword: 'контакти имоти Варна',
        secondaryKeywords: 'офис Варна Имотен Център, телефон брокер Варна, адрес агенция за имоти Варна',
        h1: 'Свържете се с Варна Имотен Център',
        h2: 'Посетете нашия офис за топла консултация или ни се обадете',
        pageDescription: 'Нашият екип е на разположение 7 дни в седмицата. Посетете нашия централен офис за персонална консултация без обвързване.',
        ogImage: 'https://images.unsplash.com/photo-1497366216548-37526070297c?w=1200&h=630&fit=crop&q=80',
        ogTitle: 'Контакти и Офис - Варна Имотен Център',
        ogDescription: 'Офис в центъра на Варна, бул. Генерал Колев 113. Обадете ни се за безплатна имотна консултация.',
        canonicalUrl: 'https://imotencentervarna.com/kontakti',
        imageAltHero: 'Офис на Варна Имотен Център бул. Генерал Колев 113',
        imageAltSecondary: 'Карта на локацията на офиса във Варна',
        noIndex: false
      },
      about: {
        id: 'about',
        pageName: 'За нас',
        urlPath: '/za-nas',
        metaTitle: 'За Варна Имотен Център - Нашата История и Мисия | Недвижими Имоти Варна',
        metaDescription: 'Научете повече за Варна Имотен Център - опит, високи стандарти и правна сигурност при сделки с недвижими имоти във Варна.',
        focusKeyword: 'за нас имоти Варна',
        secondaryKeywords: 'агенция недвижими имоти Варна, имотен център Варна, лицензирана агенция Варна',
        h1: 'Нашата история и мисия',
        h2: 'Вашият доверен партньор за покупка, продажба и наем на недвижими имоти в град Варна и региона.',
        pageDescription: 'Лицензирана агенция за недвижими имоти във Варна. Пълно съдействие при покупко-продажба, отдаване под наем, проверка на тежести и ипотечни кредити.',
        ogImage: 'https://images.unsplash.com/photo-1600585154340-be6161a56a0c?w=1200&h=630&fit=crop&q=80',
        ogTitle: 'За Нас - Варна Имотен Център',
        ogDescription: 'Професионализъм, сигурност и персонално отношение при всяка сделка с имот във Варна.',
        canonicalUrl: 'https://imotencentervarna.com/za-nas',
        imageAltHero: 'Екипът и мисията на Варна Имотен Център',
        imageAltSecondary: 'Офис и срещи с клиенти на Варна Имотен Център',
        noIndex: false
      }
    }
  }
};
